import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navbar } from "../componentes/navbar";
import { CardComponent } from "../componentes/cardComponent";
import { Form, Space, Row, Col, Button, Card } from "antd";
import { InputCustom } from "../componentes/inputComponent";
import { TablaCompleta } from "../tablas/tabla_simple";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { manejarError } from "../manejo_errores";
import { PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import {
  HeadersAuth,
  traerDatosObjeto,
  CheckExpiracion,
} from "../funciones_utiles";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { BotonPrincipal } from "../componentes/btnPrincipal";

export const CrearAdministradores = ({ sesion, setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  // Estados del Componente
  const MySwal = withReactContent(Swal);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({}); // Almacena temporalmente los datos del formulario
  const [fetchDatos, setFetchDatos] = useState([]); // Guarda los datos de los administradores obtenidos del backend
  const [refresh, setRefresh] = useState(""); // Se utiliza para forzar la actualización de la lista de administradores
  const [idUnico, setIdUnico] = useState(); // ID del administrador seleccionado para edición
  const [mostrarBotonLimpiar, setMostrarBotonLimpiar] = useState(false);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [abrirModal, setAbrirModal] = useState(false);

  // Carga de datos iniciales
  useEffect(() => {
    if (idUnico) {
      (async () => {
        const URI_ADMIN = `${process.env.REACT_APP_DOMINIO}/admin/${idUnico}`;
        const datosAdmin = await traerDatosObjeto(URI_ADMIN);
        if (datosAdmin) {
          setTempDatosFormulario(datosAdmin);
          setMostrarBotonLimpiar(true);
        } else {
          console.error("No se recibieron datos del administrador.");
          manejarAlertas("error", "No se recibieron datos del administrador.");
        }
      })();
    } else {
      // Estado inicial cuando no hay ID seleccionado
      setTempDatosFormulario({
        nombre: "",
        apellido: "",
        email: "",
        dni: "",
      });
      setMostrarBotonLimpiar(false);
    }
  }, [idUnico]);

  // Guardar administrador
  const guardarAdministrador = async (e) => {
    // e.preventDefault();
    try {
      let url = idUnico
        ? `${process.env.REACT_APP_DOMINIO}/admin/${idUnico}` // Para actualización
        : `${process.env.REACT_APP_DOMINIO}/admin`; // Para creación

      // console.log("URL:", url); // Depura la URL
      // console.log("Datos enviados:", tempDatosFormulario); // Depura los datos enviados

      let response;

      if (idUnico) {
        response = await axios.put(url, tempDatosFormulario, HeadersAuth); // Actualización
      } else {
        response = await axios.post(url, tempDatosFormulario, HeadersAuth); // Creación
      }

      if (response.status === 200) {
          manejarAlertas("success", "Guardado exitoso");
        
          setTempDatosFormulario({
            nombre: "",
            apellido: "",
            email: "",
            dni: "",
          });
          setIdUnico(null);
          setRefresh(Date.now());
          setMostrarFormulario(false); // Oculta el primer formulario
          setMostrarBotonLimpiar(false);
        
      }
    } catch (error) {
      manejarError(error);
      manejarAlertas("error", manejarError(error));

    }
  };
  const handleResetPassword = async () => {
    if (!idUnico) {
      MySwal.fire({
        title: "Error",
        text: "No hay ningún administrador seleccionado para resetear la contraseña.",
        icon: "error",
      });
      return;
    }

    const result = await MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción reseteará la contraseña del administrador a su DNI.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, resetear",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_DOMINIO}/admin/${idUnico}/reset-password`,
          {},
          HeadersAuth
        );

        if (response.status === 200) {
          
          manejarAlertas("success", "La contraseña del administrador ha sido reseteada con éxito. La nueva contraseña es su DNI.");

        }
      } catch (error) {
        
        manejarAlertas("error", manejarError(error));
      }
    }
  };
  // Obtiene la lista de administradores
  useEffect(() => {
    const fetchData = async () => {
      await fetchAdministradores();
    };

    fetchData();
  }, [refresh]);

  const fetchAdministradores = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/admin`,
        HeadersAuth
      );
      // console.log(response);
      if (response.status === 200 && Array.isArray(response.data)) {
        // console.log("Administradores obtenidos:", response.data); // Verifica en consola
        setFetchDatos(response.data); // Asigna los datos al estado
      } else {
        console.error("No se encontraron administradores.");
        manejarAlertas("error", "No se encontraron administradores.");

      }
    } catch (error) {
      manejarAlertas("error", "Error al obtener administradores.");

      console.error("Error al obtener administradores:", error);
    }
  };

  // Carga los datos de un administrador para edición
  const handleEdit = async (id) => {
    if (!id) {
      manejarAlertas("error", "Error al procesar la solicitud.");

      console.error("Error: idUnico es undefined");
      return;
    }
    try {
      const URI_ADMIN = `${process.env.REACT_APP_DOMINIO}/admin/${id}`;
      const datosAdmin = await traerDatosObjeto(URI_ADMIN);
      // console.log("datos", datosAdmin);
      // console.log("Datos del administrador obtenidos:", datosAdmin);
      setTempDatosFormulario(datosAdmin || {});
      setIdUnico(id);
      setMostrarFormulario(true);
    } catch (error) {
      console.error("Error al obtener los datos del administrador:", error);
      manejarAlertas("error", "Error al obtener los datos del administrador.");
    }
  };

  // Elimina un administrador
  const handleEliminarAdministrador = (id) => {
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_DOMINIO}/admin/${id}`,
            HeadersAuth
          );
          if (response.status === 200) {
            
            manejarAlertas("success", "El administrador ha sido eliminado.");
            setRefresh(Date.now()); // Actualiza la tabla
          }
        } catch (error) {
          manejarAlertas("error", manejarError(error));

          
        }
      }
    });
  };

  // Manejo de cambios en el formulario
  const handleChange = (e) => {
    const { id, value } = e.target;
    setTempDatosFormulario((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const limpiarCampos = () => {
    setTempDatosFormulario({
      nombre: "",
      apellido: "",
      email: "",
      dni: "",
    });
    setIdUnico(null); // Limpiar el ID del administrador seleccionado
    setMostrarBotonLimpiar(false); // Ocultar el botón "+"
  };
  // Función para mostrar el formulario y ocultar el botón
  const mostrarFormularioHandler = () => {
    setMostrarFormulario(true);
  };
  /* Configuración de la tabla */
  const elScroll = { x: 0 };
  const columns = [
    {
      title: "NOMBRE",
      key: "nombre",
      align: "center",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      render: (a) => <span>{a.nombre}</span>,
    },
    {
      title: "APELLIDO",
      key: "apellido",
      align: "center",
      sorter: (a, b) => a.apellido.localeCompare(b.apellido),
      render: (a) => <span>{a.apellido}</span>,
    },
    {
      title: "E-MAIL",
      key: "email",
      align: "center",
      sorter: (a, b) => a.email.localeCompare(b.email),
      render: (a) => <span>{a.email}</span>,
    },
    {
      title: "OPCIONES",
      key: "opciones",
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          {/* Botón de Editar */}
          <FaRegEdit
            style={{ cursor: "pointer", color: "blue" }}
            onClick={() => handleEdit(record.id)}
          />
          {/* Botón de Eliminar */}
          <FaRegTrashAlt
            style={{ cursor: "pointer", color: "red" }}
            onClick={() => handleEliminarAdministrador(record.id)}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      {/* <Navbar /> */}
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 className="titulos">Gestión de Administradores</h1>
      </section>
      {/* Formulario de Creación/Edición */}

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          margin: "1em 0",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            padding: "20px",
            margin: "0 auto",
          }}
        >
          <Row
            justify="space-between"
            align="middle"
            style={{ marginBottom: "1em" }}
          >
            <Col>
              {idUnico ? (
                <h2 className="titulos-secundarios">Editar Administrador</h2>
              ) : (
                <h2 className="titulos-secundarios">Crear Administrador</h2>
              )}
            </Col>
            <Col>
              <Space size="middle">
                {mostrarBotonLimpiar && (
                  <Button danger onClick={limpiarCampos} className="boton-azul">
                    Nuevo administrador
                  </Button>
                )}
                {idUnico && (
                  <Button
                    danger
                    onClick={handleResetPassword}
                    className="boton-azul"
                  >
                    Resetear Contraseña
                  </Button>
                )}
              </Space>
            </Col>
          </Row>
          <hr></hr>
          {mostrarFormulario && (
            <Form layout="vertical" onFinish={guardarAdministrador}>
              <Row gutter={16}>
                <Col xs={24} sm={6}>
                  <InputCustom
                    tipo="number"
                    nombreCampo="DNI"
                    idCampo="dni"
                    elPlaceholder="Ingrese el dni"
                    elValue={tempDatosFormulario.dni || ""}
                    onChange={handleChange}
                    required={true}
                  />
                </Col>
                <Col xs={24} sm={6}>
                  <InputCustom
                    tipo="email"
                    nombreCampo="Email"
                    idCampo="email"
                    elPlaceholder="Ingrese el email"
                    elValue={tempDatosFormulario.email || ""}
                    onChange={handleChange}
                    required={true}
                  />
                </Col>

                <Col xs={24} sm={6}>
                  <InputCustom
                    tipo="text"
                    nombreCampo="Nombre"
                    idCampo="nombre"
                    elPlaceholder="Ingrese el nombre"
                    elValue={tempDatosFormulario.nombre || ""}
                    onChange={handleChange}
                    required={true}
                  />
                </Col>

                <Col xs={24} sm={6}>
                  <InputCustom
                    tipo="text"
                    nombreCampo="Apellido"
                    idCampo="apellido"
                    elPlaceholder="Ingrese el apellido"
                    elValue={tempDatosFormulario.apellido || ""}
                    onChange={handleChange}
                    required={true}
                  />
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} sm={6} className="botonesResponsive"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    textAlign: "right",
                    marginTop: 21
                  }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="boton-principal"
                      style={{ width: "100%" }}

                    >
                      {idUnico ? "Actualizar" : "Guardar"}
                    </Button>
                </Col>
              </Row>
            </Form>
          )}
        </div>
      </section>
      {/* Tabla de resultados */}
      <div
        className="botonDescargar"
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <TablaCompleta
          tituloPDF={"administradores"}
          elScroll={elScroll}
          columns={columns}
          fetchDatos={fetchDatos.length > 0 ? fetchDatos : []}
          rowKey={"id"}
          mostrarBoton={false}
          gestionTabla={
            <Row style={{ gap: "10px" }}>
              {!mostrarFormulario && (
                <BotonPrincipal
                  texto="Agregar administrador"
                  onClick={mostrarFormularioHandler}
                />
              )}
            </Row>
          }
        />
      </div>
    </div>
  );
};
